import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const convertHtmlToPdf = async (
  html: string
): Promise<{
  blob: Blob;
  size: number;
  blobUrl: string;
}> => {
  try {
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = html;
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.top = '-9999px';
    tempContainer.style.width = '800px';
    tempContainer.style.backgroundColor = '#ffffff';
    tempContainer.style.padding = '20px';
    tempContainer.style.fontFamily = 'Arial, sans-serif';

    document.body.appendChild(tempContainer);

    await new Promise(resolve => setTimeout(resolve, 100));

    const canvas = await html2canvas(tempContainer, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      width: 800,
      height: tempContainer.scrollHeight,
    });

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });

    const imgWidth = 210; // A4 width in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

    const links = tempContainer.querySelectorAll('a');
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href) {
        const rect = link.getBoundingClientRect();
        const containerRect = tempContainer.getBoundingClientRect();

        const x = ((rect.left - containerRect.left) * imgWidth) / 800;
        const y = ((rect.top - containerRect.top) * imgHeight) / canvas.height;
        const width = (rect.width * imgWidth) / 800;
        const height = (rect.height * imgHeight) / canvas.height;

        pdf.link(x, y, width, height, { url: href });
      }
    });

    document.body.removeChild(tempContainer);

    const pdfBlob = pdf.output('blob');
    const blobUrl = URL.createObjectURL(pdfBlob);

    return {
      blob: pdfBlob,
      size: pdfBlob.size,
      blobUrl,
    };
  } catch (error) {
    console.error('Error converting HTML to PDF:', error);
    throw error;
  }
};
